import { render, staticRenderFns } from "./Knowledgelits.vue?vue&type=template&id=1fd39317&scoped=true"
import script from "./Knowledgelits.vue?vue&type=script&lang=js"
export * from "./Knowledgelits.vue?vue&type=script&lang=js"
import style0 from "./Knowledgelits.vue?vue&type=style&index=0&id=1fd39317&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd39317",
  null
  
)

export default component.exports